export const deviceTypes = {
    1: {
        name: "Картходлер",
        value: "CHARTHOLDER",
        img: "cardholder",
    },
    2: {
        name: "Выключатель",
        value: "SWITCH",
        img: "switch",
    },
    3: {
        name: "Датчик движения",
        value: "MOTION_SENSOR",
        img: "motion_sensor",
    },
    4: {
        name: "Датчик открытия",
        value: "OPENING_SENSOR",
        img: "opening_sensor",
    },
    5: {
        name: "Вентиляция",
        value: "VENTILATION",
        img: "ventilation",
    },
    6: {
        name: "Датчик протечки",
        value: "LEAK_SENSOR",
        img: "leak_sensor",
    },
    7: {
        name: "Датчик температуры воздуха",
        value: "AIR_TEMPERATURE_SENSOR",
        img: "thermometer",
    },
    8: {
        name: "Шторы с приводом",
        value: "CURTAINS",
        img: "curtains",
    },
    9: {
        name: "Освещение",
        value: "LIGHTING",
        img: "lighting",
    },
    10: {
        name: "Розетка",
        value: "SOCKET",
        img: "socket",
    },
    11: {
        name: "Холодильник",
        value: "FRIDGE",
        img: "fridge",
    },
    12: {
        name: "Отопление",
        value: "HEATING",
        img: "heating",
    },
    13: {
        name: "Полы с подогревом",
        value: "UNDERFLOOR_HEATING",
        img: "warm_floor",
    },
    14: {
        name: "Клапан перекрытия воды",
        value: "WATER_SHUT_OFF",
        img: "water_shut_off",
    },
    15: {
        name: "Диммируемое освещение",
        value: "DIMMABLE_LIGHTING",
        img: "lighting",
    },
    16: {
        name: "Телевизор",
        value: "TELEVISION",
        img: "tv",
    },
    17: {
        name: "Датчик освещения",
        value: "LIGHT_SENSOR",
        img: "light_sensor",
    },
    18: {
        name: "Датчик влажности",
        value: "AIR_HUMIDITY_SENSOR",
        img: "humidity_sensor",
    },
}
export default deviceTypes;
